import { useEffect } from 'react'
import {getListTypeOfs} from '../../../services/sKPI/typeOf.service'
import { getListDistributionGroups, getListUSerDistributionGroup, getUsers } from '../../../services/sNotificationAlerts/distributionGroups.service';
import { isNullUndefined, isNullUndefinedOrEmptyOrZero, treeify } from '../../../common/Helpers';

const useGetAllUsers = (userList, setUserList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsers();

                const response = serviceResponse.data;
                
                if (response.succeeded) {

                    for (let index = 0; index < response.data.length; index++) {
                        const element = response.data[index];
                        element.fullName = response.data[index].firstname + " " + response.data[index].lastname;
                    }

                    let response_aux = treeify(response.data !== null ? response.data : [], 'username', null, 'children', "fullName", "username")

                    for (let index = 0; index < response_aux.length; index++) {
                        const element = response_aux[index];
                        element.checked = false;
                    }
    
                    setUserList(response_aux);
                }
                else {
                    setUserList([]);
                }
            }
            catch (error) {
                setUserList([]);
            }
        }
        
        if (userList === null) {
            getData()
        }
    }, [ userList, setUserList]);
}

const useGetDistributionGroupsMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListDistributionGroups();
                const response = serviceResponse.data;

                setMantainer(response.data);
            }
            catch (error) {
                setMantainer([])
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

const useGetListUserDistributionGroupMantainer = (distributionGroupId, assignamentUserList, setAssignamentUserList, inputParam_IsPanelOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {

                let serviceResponse = await getListUSerDistributionGroup(distributionGroupId);

                const response = serviceResponse.data.data;

                for (let index = 0; index < response.length; index++) {
                    response[index].fullName = response[index].firstname + " " + response[index].lastname;
                }

                setAssignamentUserList(prevState => ({
                    ...prevState,
                    data: response
                }));
            }
            catch (error) {
                setAssignamentUserList(prevState => ({
                    ...prevState,
                    data: []
                }));
            }
        }
        
        if (assignamentUserList.data === null && !isNullUndefinedOrEmptyOrZero(distributionGroupId) && inputParam_IsPanelOpen === true) {
            getData()
        }
    }, [assignamentUserList, setAssignamentUserList, inputParam_IsPanelOpen]);
}

const useGetListUserDistributionGroup = (distributionGroupId, assignamentUserList, setAssignamentUserList, inputParam_IsPanelOpen, fireDistributionGroupSearch, setFireDistributionGroupSearch) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {

                let serviceResponse = await getListUSerDistributionGroup(distributionGroupId);

                const response = serviceResponse.data.data;

                for (let index = 0; index < response.length; index++) {
                    response[index].fullName = response[index].firstname + " " + response[index].lastname;
                    response[index].key = response[index].id;
                    response[index].text = response[index].fullName;
                    response[index].principal = false;
                }

                setFireDistributionGroupSearch(false)
                setAssignamentUserList(response);
            }
            catch (error) {
                setFireDistributionGroupSearch(false)
                setAssignamentUserList([]);
            }
        }
        
        if (!isNullUndefinedOrEmptyOrZero(distributionGroupId) && (assignamentUserList === null || fireDistributionGroupSearch === true) && inputParam_IsPanelOpen === true) {
            getData()
        }
    }, [distributionGroupId, assignamentUserList, setAssignamentUserList, inputParam_IsPanelOpen, , fireDistributionGroupSearch, setFireDistributionGroupSearch]);
}

export {
    useGetAllUsers,
    useGetDistributionGroupsMaintainer,
    useGetListUserDistributionGroupMantainer,
    useGetListUserDistributionGroup
}